import { Search, X, Star } from 'lucide-react';

function OverlappingAvatars({ initials, active }) {
  if (!initials?.length) return null;

  return (
    <div className="mt-3 flex items-center">
      {initials.slice(0, 3).map((letter, index) => (
        <div
          key={`${letter}-${index}`}
          className={`flex h-8 w-8 items-center justify-center rounded-full border-2 text-sm font-semibold ${
            active
              ? 'border-white/90 bg-white/15 text-white backdrop-blur-sm'
              : 'border-gray-300 bg-white/60 text-gray-700 backdrop-blur-sm'
          }`}
          style={{
            marginLeft: index > 0 ? '-10px' : 0,
            zIndex: 10 - index,
          }}
        >
          {letter}
        </div>
      ))}
    </div>
  );
}

export default function PatientSearch({ value, onChange, placeholder }) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-xl bg-gray-100 py-2.5 pl-10 pr-10 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary/20"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export function WardChips({ wards, activeWard, onSelect, translateWard }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1">
      {wards.map((ward) => (
        <button
          key={ward}
          type="button"
          onClick={() => onSelect(ward)}
          className={`shrink-0 rounded-pill px-3 py-1.5 text-xs font-semibold ${
            activeWard === ward
              ? 'bg-primary text-white'
              : 'bg-gray-100 text-gray-600'
          }`}
        >
          {translateWard ? translateWard(ward) : ward}
        </button>
      ))}
    </div>
  );
}

export function SummaryToggle({
  active,
  label,
  count,
  onClick,
  isFavorite,
  avatarInitials = [],
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex min-h-[5.5rem] flex-1 flex-col rounded-2xl px-4 py-3.5 text-left transition-colors ${
        active
          ? 'bg-primary text-white shadow-card'
          : 'border border-gray-200 bg-gray-100 text-gray-900'
      }`}
    >
      <div className="flex items-center gap-1.5">
        {isFavorite && (
          <Star
            className={`h-4 w-4 shrink-0 ${
              active ? 'fill-white text-white' : 'text-gray-500'
            }`}
            strokeWidth={2}
          />
        )}
        <span className="text-base font-bold tracking-tight">{label}</span>
      </div>
      <span
        className={`mt-0.5 text-sm font-medium ${
          active ? 'text-white/90' : 'text-gray-600'
        }`}
      >
        {count}
      </span>
      {(active || avatarInitials.length > 0) && active && (
        <OverlappingAvatars initials={avatarInitials} active={active} />
      )}
    </button>
  );
}
